import { APP } from '@services';
import styles from './Footer.module.css';
import { Box, Flex, Separator, Strong, Text } from '@radix-ui/themes';
import { Trans, useTranslation } from 'react-i18next';
import { EnvSwitcher } from '../EnvSwitcher';

export const Footer = () => {
    useTranslation();
    const year = new Date().getFullYear();
    const version = APP.Version;

    return (
        <Flex className={styles.footer} gap='4'>
            <Text>
                <Trans i18nKey='common:copyright' values={{ year }} />
            </Text>
            <Separator size={'1'} orientation={'horizontal'} />
            <Text>
                <Trans
                    i18nKey={'common:version'}
                    values={{ version }}
                    components={{ b: <Strong /> }}
                />
            </Text>
            <Separator size={'1'} orientation={'horizontal'} />
            <Text>{APP.Environment}</Text>
            <Box position={'absolute'} right={'1'}>
                <EnvSwitcher />
            </Box>
        </Flex>
    );
};

export default Footer;
